<template>
    <div v-if="config !== null" class="apron-configurator">

        <div class="apron-configurator__label">
            <h4 class="font-weight-light color-blue mb-3 mt-1">{{config.model.name}}</h4>
            <!--<slot></slot>-->
            <p v-if="config.model.ribbonsForApron.length == 0"><b-icon-exclamation-circle-fill class="color-orange" /> {{ $t('configurator.noRibbons') }}</p>
        </div>

        <div class="apron-configurator__panels">
            <!-- Apron fabric color -->
            <CollapsiblePanel v-model="blnShowFabricPanel" :title="$t('addEditApron.fabricColor') + '*'">
                <div class="pl-2 pb-2">
                    <p class="m-0 small"><b-icon-exclamation-circle-fill animation="throb " class="color-magenta" /> {{ $t('configurator.colorWarning') }}</p>
                </div>
                <div class="pb-3">
                    <div v-for="(fabric, index) in config.model.fabricsForApron" :key="index" class="swatch-wrapper" :class="{selectedSwatch: isSelectedFabric(fabric.fabricColorID)}">

                        <div v-on:click="config.fabricColorID = fabric.fabricColorID; " :style="{ 'backgroundColor': fabric.fabricColor.hex}" class="color-swatch" :class="{isMetallic : fabric.fabricColor.metallic}">
                            <div class="check">
                                <b-icon-check font-scale="4" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-2 mb-1 ml-2 small">{{ $t('configurator.selectedColor') }} <span class="font-weight-bold">{{facbricColorName}}</span></p>
                </div>
            </CollapsiblePanel>

            <!-- Apron ribbon color -->
            <CollapsiblePanel v-if="config.model.ribbonsForApron.length > 0" v-model="blnShowRibbonPanel" v-on:click="blnShowRibbonPanel = !blnShowRibbonPanel" :title="$t('addEditApron.ribbonColor') + '*'" class="mt-3">
                <div class="pl-2  pb-2">
                    <p class="m-0 small"><b-icon-exclamation-circle-fill animation="throb " class="color-magenta" /> {{ $t('configurator.ribbonPreviewTip') }} </p>
                </div>
                <div class="pb-3">
                    <div v-for="(ribbon, index) in config.model.ribbonsForApron" :key="index" class="swatch-wrapper" :class="{selectedSwatch: isSelectedRibbon(ribbon.ribbonColorID)}">

                        <div v-on:click="config.ribbonColorID = ribbon.ribbonColorID" class="swatch">

                            <div class="check">
                                <b-icon-check font-scale="4" />
                            </div>

                            <img :src="ribbon.ribbonColor.previewFilePath" />
                        </div>

                    </div>
                    <p class="mt-2 mb-1 ml-2 small">{{ $t('configurator.selectedColor') }} <span class="font-weight-bold">{{ribbonColorName}}</span></p>
                </div>
            </CollapsiblePanel>

            <CollapsiblePanel :title="$t('configurator.protectiveMaterial') + '*'" class="mt-3">
                <div class="p-2">
                    <label class="w-100">{{ $t('configurator.material') }}</label>
                    <select v-model="config.internalMaterial" class="w-100">
                        <option :value=0>--{{ $t('general.pleaseSelect') }}--</option>
                        <option :value=2>Opaque Action (Light Lead)</option>
                        <option :value=1>Opaque Fusion (No Lead)</option>
                    </select>

                    <label class="w-100">{{ $t('addEditApron.pbEquivalence') }} ({{ $t('addEditApron.front') }})</label>
                    <select v-model="config.pbEqFront" class="w-100">
                        <option :value=-1>--{{ $t('general.pleaseSelect') }}--</option>
                        <option :value=2>0.25mm</option>
                        <option :value=3>0.35mm</option>
                        <option :value=5>0.50mm</option>
                    </select>

                    <div v-if="$store.state.chosenCategory == 2">
                        <label class="w-100">{{ $t('addEditApron.pbEquivalence') }} ({{ $t('addEditApron.back') }})</label>
                        <select v-model="config.pbEqBack" class="w-100">
                            <option :value=-1>--{{ $t('general.pleaseSelect') }}--</option>
                            <option :value=2>0.25mm</option>
                            <option :value=3>0.35mm</option>
                            <option :value=5>0.50mm</option>
                        </select>
                    </div>


                </div>
            </CollapsiblePanel>

            <CollapsiblePanel :title="$t('quoteDetail.sizing') + '*'" class="mt-3">
                <div class="p-2 configurator-sizing">

                   
                        <div class="configurator-sizing__size">
                            <label class="w-100">{{ $t('addEditApron.size') }}</label>
                            <size-dropdown v-model="config.size" class="w-100" :manufacturer-id="config.model.manufacturerID"></size-dropdown>
                        </div>
                   

                    <div class="configurator-sizing__adjustments">
                        <div class="configurator-sizing__length">
                            <label class="w-100">{{ $t('configurator.lengthAdjustment') }}</label>
                            <select v-model="cptLengthAdjustment" class="w-100">
                                <option :value=15>+15cm ({{config.model.defaultLength + 15}}cm)</option>
                                <option :value=10>+10cm ({{config.model.defaultLength + 10}}cm)</option>
                                <option :value=5>+5cm ({{config.model.defaultLength + 5}}cm)</option>
                                <option :value=0>{{ $t('configurator.noAdjustment') }} ({{config.model.defaultLength}}cm)</option>
                                <option :value=-5>-5cm ({{config.model.defaultLength - 5}}cm)</option>
                                <option :value=-10>-10cm ({{config.model.defaultLength - 10}}cm)</option>
                                <option :value=-15>-15cm ({{config.model.defaultLength - 15}}cm)</option>
                            </select>
                        </div>
                        <div class="configurator-sizing__overlap">
                            <label class="w-100">{{ $t('configurator.extraOverlap') }}</label>
                            <select v-model="cptOverlapAdjustment" class="w-100">
                                <option :value=12>+12cm</option>
                                <option :value=9>+9cm</option>
                                <option :value=6>+6cm</option>
                                <option :value=3>+3cm</option>
                                <option :value=0>{{ $t('configurator.noAdjustment') }}</option>
                            </select>

                        </div>
                    </div>

                </div>
            </CollapsiblePanel>

            <CollapsiblePanel :title="$t('configurator.customization')" class="mt-3">
                <div class="p-2">
                    <label class="w-100">{{ $t('configurator.monogramLine') }} 1</label>
                    <input v-model="config.monogramLine1" class="w-100" type="text" />

                    <label class="w-100 mt-2">{{ $t('configurator.monogramLine') }} 2</label>
                    <input v-model="config.monogramLine2" class="w-100" type="text" />

                    <div class="mt-3">
                        <input v-model="config.velcroMonogram" type="checkbox" class="mr-2" />
                        <label class="">{{ $t('configurator.monogramVelcro') }}</label>
                    </div>

                    <div v-if="config.model.setModel == null">
                        <img src="../../../assets/placement-apron.svg" class="w-100" />
                    </div>
                    <div v-else>
                        <img src="../../../assets/placement-vest-skirt.svg" class="w-100" />
                    </div>

                    <!--<label class=" w-100 mt-4">Add Logo</label>
                    <input id="FileSector" name="file" type="file" ref="file" accept=".jpg, .png, .bmp" multiple="multiple" class="hide-upload-button" data-multiple-caption="{count} files selected">
                    <label for="FileSector" class="upload-button blue-gradient d-inline-block mt-2 mr-3"><b-icon-upload class="mr-2" /> <span>Upload</span></label>-->

                </div>
            </CollapsiblePanel>


        </div>
    </div>


</template>

<script>
    import CollapsiblePanel from '@/private/components/UI-elements/CollapsiblePanel.vue'
    import SizeDropdown from "@/private/components/UI-elements/SizeDropdown.vue";
	import { configToSku } from '@/scripts/General.js'

    export default {
        name: 'ApronConfig',
        components: {
            CollapsiblePanel,
            SizeDropdown
        },
        props: {
            value: Object,
            queryParamToUpdate: String,
            favouriteid: { type: Number, required: true}
        },
        data: function () {

            return {
                config: this.value,
                blnShowFabricPanel: true,
                blnShowRibbonPanel: false,
                //facbricColorName: 'None selected',
                //            ribbonColorName: 'None selected',
                facbricColorName: this.$t("general.noneSelected"),
                ribbonColorName: this.$t("general.noneSelected"),
            }

        },
        created: function () {

        },
        methods: {
            UpdateAdjustment: function (AdjustmentType, Value) {
                if (this.config.sizeAdjustments.filter(x => x.adjustmentType == AdjustmentType).length == 0) {
                    //Add
                    var newAdjustment = {
                        adjustmentType: AdjustmentType,
                        parameter1: Value
                    }
                    this.config.sizeAdjustments.push(newAdjustment);
                } else {
                    //Update
                    for (var i = 0; i < this.config.sizeAdjustments.length; i++) {
                        if (this.config.sizeAdjustments[i].adjustmentType == AdjustmentType) {
                            this.config.sizeAdjustments[i].parameter1 = Value
                        }
                    }
                }
            },
            isSelectedFabric: function (fabricColorID) {
                if (fabricColorID == this.config.fabricColorID) {
                    return 'bold'
                } else {
                    return ''
                }
            },
            isSelectedRibbon: function (ribbonColorID) {
                if (ribbonColorID == this.config.ribbonColorID) {
                    return 'bold'
                } else {
                    return ''
                }
            },
            configToSku: function () {

				this.config.sku = configToSku(this.config, this.cptLength, this.cptOverlapAdjustment)

				//Update SKU in store
				if (this.queryParamToUpdate == "sku") {
					this.$store.commit('SET_sku1', this.config.sku)
				} else {
					this.$store.commit('SET_sku2', this.config.sku)
				}

				//change URL
                if (this.$store.state.sku2 == '') {
                 
					this.$router.replace({ name: this.$route.name, params: { favouriteid: this.favouriteid, sku: this.$store.state.sku1 } }).catch(() => { })
				} else if (this.$store.state.sku1 == '') {
					this.$router.replace({ name: this.$route.name, params: { favouriteid: this.favouriteid, sku2: this.$store.state.sku2 } }).catch(() => { })
				} else {
					this.$router.replace({ name: this.$route.name, params: { favouriteid: this.favouriteid, sku: this.$store.state.sku1, sku2: this.$store.state.sku2 } }).catch(() => { })
				}
            },
            
        },
        computed: {
            cptLengthAdjustment: {
                get: function () {
                    if (this.config.sizeAdjustments.filter(x => x.adjustmentType == 1).length == 0) {
                        return 0
                    } else {
                        return this.config.sizeAdjustments.filter(x => x.adjustmentType == 1)[0].parameter1
                    }
                },
                set: function (newValue) {

                    if (newValue == 0) {
                        //Remove adjustment
                        for (var i = 0; i < this.config.sizeAdjustments.length; i++) {
                            if (this.config.sizeAdjustments[i].adjustmentType == 1) {
                                this.config.sizeAdjustments.splice(i, 1)
                                break;
                            }
                        }
                    } else {
                        //Update adjustment
                        this.UpdateAdjustment(1, newValue)
                    }


                },
            },
            cptOverlapAdjustment: {
                get: function () {
                    if (this.config.sizeAdjustments.filter(x => x.adjustmentType == 2).length == 0) {
                        return 0
                    } else {
                        return this.config.sizeAdjustments.filter(x => x.adjustmentType == 2)[0].parameter1
                    }
                },
                set: function (newValue) {

                    if (newValue == 0) {
                        //Remove adjustment
                        for (var i = 0; i < this.config.sizeAdjustments.length; i++) {
                            if (this.config.sizeAdjustments[i].adjustmentType == 2) {
                                this.config.sizeAdjustments.splice(i, 1)
                                break;
                            }
                        }
                    } else {
                        //Update adjustment
                        this.UpdateAdjustment(2, newValue)
                    }

                },
            },
            cptLength: function () {
                return this.config.model.defaultLength + this.cptLengthAdjustment
            },

        },
        watch: {
            config: {
                deep: true,
                handler: function (newValue) {

                    if (newValue == null) {
                        //Could be a skirt item that was removed
                        //this.resetSku();
                    } else if (newValue.modelID != 0) {
                        this.configToSku()
                    }

                    //v-model outwards
                    this.$emit('input', newValue)

                }
            },
            value: function (newValue) {

                //v-model-inward
                this.config = newValue

                if (newValue == null) {
                    //Could be a skirt item that was removed
                    //this.resetSku();
                } else if (newValue.modelID != 0) {
                    this.configToSku()
                }
            },
            blnShowFabricPanel: function (newValue) {
                if (newValue == true) {
                    this.blnShowRibbonPanel = false
                }

            },
            blnShowRibbonPanel: function (newValue) {
                if (newValue == true) {
                    this.blnShowFabricPanel = false
                }
            },
            'config.fabricColorID': function (newValue) {
                if (newValue == null) {
                    this.config.fabricColor == null;
                    return;
                }

                for (var i = 0; i < this.config.model.fabricsForApron.length; i++) {
                    if (this.config.model.fabricsForApron[i].fabricColorID == newValue) {

                        this.config.fabricColor = this.config.model.fabricsForApron[i].fabricColor;

                        //set label apron color box
                        this.facbricColorName = this.config.fabricColor.name
                        break;
                    }
                }

            },
            'config.ribbonColorID': function (newValue) {
                if (newValue == null) {
                    this.config.ribbonColor == null;
                    return
                }
                for (var i = 0; i < this.config.model.ribbonsForApron.length; i++) {
                    if (this.config.model.ribbonsForApron[i].ribbonColorID == newValue) {

                        this.config.ribbonColor = this.config.model.ribbonsForApron[i].ribbonColor;

                        //set label ribbon color box
                        this.ribbonColorName = this.config.ribbonColor.name
                        break;
                    }
                }

            },
            'config.includeInQuote': function () {
                this.configToSku();
            },
        },
        mounted: function () {
			if (this.config != null) {
				if (this.config.fabricColorID != 0) {
					this.facbricColorName = this.config.fabricColor.name
				}
				if (this.config.ribbonColorID != 0) {
					this.ribbonColorName = this.config.ribbonColor.name
				}
			}
        },
        updated: function () {

        }
    }
</script>
